/** Client-facing message bubble (orchestration mid-flow or outcome). */

import { AgentMessageHtml } from "@/components/missions/AgentMessageHtml";
import { AgenticMessageBubble } from "@/components/ui/agentic-message-bubble";

interface AgentMessageBubbleProps {
  html: string;
  agentName?: string;
  label?: string;
}

export function AgentMessageBubble({
  html,
  agentName = "Agent",
  label = "Message to the client",
}: AgentMessageBubbleProps) {
  return (
    <AgenticMessageBubble
      role="agent"
      agentName={agentName}
      label={label}
      bubbleClassName="ring-1 ring-white/[0.06]"
    >
      <div className="prose prose-sm prose-invert max-w-none [&_*]:text-slate-200">
        <AgentMessageHtml html={html} />
      </div>
    </AgenticMessageBubble>
  );
}
